import InputTypesEnum from '../../../Enums/InputTypesEnum';
import UserService from '../../../Services/userService';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';
import FreelancerAgencyUserTypesEnum from '../../../Enums/FreelancerAgencyUserTypesEnum';
import selectHelper from '../../../Helpers/selectHelper';
import SearchParamsBase from '../../../Elements/SearchParamsBase';

export default class FreelancerUserSearchParams extends SearchParamsBase {
  initialize() {
    this.FreelanceUserId = '';
    this.CompanyName = '';
    this.Name = '';
    this.Email = '';
    this.OfficeName = OfficeHelper.GetDefaultOfficeIds(UserService.GetOfficeIdOfLoggedInUser());
    this.RMSuperVisorUserName = '';
    this.DQSupervisorUserName = '';
    this.KAMSuperVisorUserName = '';
    this.PrimaryFreelancerUserName = '';
    this.UserType = '';
    this.IsResourceManager = '';
    this.IsDataQualityManager = '';
    this.IsKAM = '';
    this.IsFieldworkPartner = '';
    this.ApolloMgrId1 = '';
    this.ApolloMgrId2 = '';
    this.ApolloMgrId1Or2 = '';
    this.IncludePrimaryFreelancerUser = 'true';
    this.ExcludedFeeId = '';
    this.IsActive = '';
  }

  static fieldsInSearchBox = [
    { fieldName: 'FreelanceUserId', label: 'Vendor Id', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'Name', label: 'Name', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'OfficeName',
      label: 'Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupSelect,
      roleKey: 'Freelancer_inputfield_VendorAdminFinanceAdmin',
    },
    { fieldName: 'Email', label: 'Email', className: 'col-4', type: InputTypesEnum.Email },
    {
      fieldName: 'PrimaryFreelancerUserName',
      label: 'Primary Freelancer',
      className: 'col-4',
      type: InputTypesEnum.PrimaryFreelancerUserSelect,
      idFilter: (searchItem) => searchItem.OfficeName,
      disabled: (item) => OfficeHelper.ToOfficeIdList(item.OfficeName).length === 0,
    },
    {
      fieldName: 'UserType',
      label: 'User Type',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: FreelancerUserSearchParams.getUserTypeSelectOptions(),
    },
    {
      fieldName: 'IsResourceManager',
      label: 'Is Resource Manager?',
      className: 'col-3',
      type: InputTypesEnum.EmptyYesNoSelect,
    },
    {
      fieldName: 'IsDataQualityManager',
      label: 'Is DataQuality?',
      className: 'col-3',
      type: InputTypesEnum.EmptyYesNoSelect,
    },
    { fieldName: 'IsKAM', label: 'Is KAM?', className: 'col-3', type: InputTypesEnum.EmptyYesNoSelect },
    {
      fieldName: 'IsFieldworkPartner',
      label: 'Is Fieldwork Partner?',
      className: 'col-3',
      type: InputTypesEnum.EmptyYesNoSelect,
    },
    { fieldName: 'IsActive', label: 'Is Active?', className: 'col-3', type: InputTypesEnum.EmptyYesNoSelect },
  ];

  static getUserTypeSelectOptions() {
    return selectHelper.generateSelectValues([
      '',
      FreelancerAgencyUserTypesEnum.Agency,
      FreelancerAgencyUserTypesEnum.UserWithAgency,
      FreelancerAgencyUserTypesEnum.Agency,
    ]);
  }

  static iconName = 'fa-solid fa-search';
  static saveType = 'FreelancerUserSearchParams';

  //---------------------------
}
